import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type OrganizationPermissionCodes =
  | 'EDIT_ORGANIZATION'
  | 'ACCESS_ORGANIZATION_ANALYTICS'
  | 'GET_ORGANIZATION_USERS'
  | 'SEND_ORGANIZATION_INVITATIONS'
  | 'DELETE_ORGANIZATION_INVITATIONS'
  | 'GET_ORGANIZATION_USER'
  | 'EDIT_ORGANIZATION_USER'
  | 'REMOVE_ORGANIZATION_USER'
  | 'GET_ORGANIZATION_TEAMS'
  | 'CREATE_TEAM'
  | 'EDIT_TEAM'
  | 'DELETE_TEAM'
  | 'CREATE_ORGANIZATION_JOB_POSTING';

const useGetOrganizationPermissions = getPermissionsHook<
  OrganizationPermissionCodes,
  { organizationId: string }
>({
  entityName: 'organizationPermissions',
  fetch: ({ organizationId }) =>
    clientApi.getOCClient().helpers.user.me.getOrganizationPermissions(organizationId),
});

export default useGetOrganizationPermissions;
